import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
        marginTop: '60px'
    }
}));
